import { __decorate } from "tslib";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { AutoEncoder, field, StringDecoder } from '@simonbackx/simple-encoding';
export class KeychainItem extends AutoEncoder {
    /**
     * Should be unique (by database constraint)
     */
    getIdentifier() {
        return this.publicKey;
    }
}
__decorate([
    field({ decoder: StringDecoder })
], KeychainItem.prototype, "publicKey", void 0);
__decorate([
    field({ decoder: StringDecoder })
], KeychainItem.prototype, "encryptedPrivateKey", void 0);
//# sourceMappingURL=KeychainItem.js.map